import React, { memo } from "react";
//dls
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { FullWidthButton } from "@swiggy-private/dls-web-core/dist/components/FullWidthButton";
//test-ids
import { EMPTY_COUPON_PAGE_TEST_IDS } from "@swiggy-private/cart-test-ids";
//styles
import { Container, ButtonWrapper, DescriptionText, ContentWrapper } from "./styles";
//constants
import { EMPTY_COUPON_PAGE_CONSTANTS } from "./constants";

interface EmptyCouponPageProps {
    onCTAClick: VoidFunction;
}

const EmptyCouponPage = ({ onCTAClick }: EmptyCouponPageProps) => {
    return (
        <Container data-testid={EMPTY_COUPON_PAGE_TEST_IDS.CONTAINER}>
            <ContentWrapper>
                <Image
                    cloudinaryId={EMPTY_COUPON_PAGE_CONSTANTS.IMAGE.CLOUDINARY_ID}
                    width={EMPTY_COUPON_PAGE_CONSTANTS.IMAGE.WIDTH}
                    height={EMPTY_COUPON_PAGE_CONSTANTS.IMAGE.HEIGHT}
                    alt={EMPTY_COUPON_PAGE_CONSTANTS.IMAGE.ALT}
                />
                <Text
                    data-testid={EMPTY_COUPON_PAGE_TEST_IDS.HEADING}
                    variant="V2.heading2.neutral.black"
                    color="text_Highest_Emphasis"
                >
                    {EMPTY_COUPON_PAGE_CONSTANTS.TEXT.HEADING}
                </Text>
                <DescriptionText
                    data-testid={EMPTY_COUPON_PAGE_TEST_IDS.DESCRIPTION}
                    variant="V2.body1.neutral.regular"
                    color="text_Med_Emphasis"
                >
                    {EMPTY_COUPON_PAGE_CONSTANTS.TEXT.DESCRIPTION}
                </DescriptionText>
                <ButtonWrapper>
                    <FullWidthButton
                        data-testid={EMPTY_COUPON_PAGE_TEST_IDS.CTA_BUTTON}
                        variant="tertiary"
                        onClick={onCTAClick}
                    >
                        {EMPTY_COUPON_PAGE_CONSTANTS.TEXT.BUTTON_TEXT}
                    </FullWidthButton>
                </ButtonWrapper>
            </ContentWrapper>
        </Container>
    );
};

export default memo(EmptyCouponPage);
